// components/StarRating.tsx
import { FaStar } from 'react-icons/fa';

interface StarRatingProps {
  rating: number;
  onRating: (rating: number) => void;
  'aria-label'?: string;
}

export function StarRating({ rating, onRating, 'aria-label': ariaLabel }: StarRatingProps) {
  return (
    <div
      className="flex gap-1 px-4 pb-4"
      role="radiogroup"
      aria-label={ariaLabel || "Avaliação por estrelas"}
    >
      {[1, 2, 3, 4, 5].map(star => (
        <button
          key={star}
          type="button"
          role="radio"
          aria-checked={rating >= star}
          aria-label={`${star} estrela${star > 1 ? 's' : ''}`}
          className={`cursor-pointer transition-all duration-200 hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 rounded ${
            rating >= star
              ? 'text-amber-400 hover:text-amber-400'
              : 'text-gray-400 hover:text-amber-300'
          }`}
          onClick={() => onRating(star)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onRating(star);
            }
          }}
        >
          <FaStar size={28} />
        </button>
      ))}
    </div>
  );
}
